import ReadWidgetDataClient from 'use-case/widgets/data/read/readWidgetDataClient';
import ReadWidgetDataCriteria from 'use-case/widgets/data/read/readWidgetDataCriteria';

const isFrame = (criteria: ReadWidgetDataCriteria) => criteria.widgetId.includes('a4_header') || criteria.widgetId.includes('a4_footer');

const isTextBlock = (criteria: ReadWidgetDataCriteria) => criteria.destination === 'texts';

const readProxyWidgetDataRouterClient = (
    frameClient: ReadWidgetDataClient,
    textBlockClient: ReadWidgetDataClient,
    defaultClient: ReadWidgetDataClient
): ReadWidgetDataClient => (criteria: ReadWidgetDataCriteria) => {
    if (isFrame(criteria)) {
        return frameClient(criteria);
    }

    if (isTextBlock(criteria)) {
        return textBlockClient(criteria);
    }

    return defaultClient(criteria);
};

export default readProxyWidgetDataRouterClient;
